var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAvatarDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C8.01325 0 0 8.01325 0 17.5C0 26.9867 8.01325 35 17.5 35C26.9867 35 35 26.9867 35 17.5C35 8.01325 26.9867 0 17.5 0ZM17.5 8.75C20.5222 8.75 22.75 10.976 22.75 14C22.75 17.024 20.5222 19.25 17.5 19.25C14.4795 19.25 12.25 17.024 12.25 14C12.25 10.976 14.4795 8.75 17.5 8.75ZM8.5645 25.851C10.1342 23.541 12.7522 22.001 15.75 22.001H19.25C22.2495 22.001 24.8658 23.541 26.4355 25.851C24.199 28.245 21.0263 29.75 17.5 29.75C13.9738 29.75 10.801 28.245 8.5645 25.851Z",
    fill: "#BFD1D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAvatarDefault);
export default __webpack_public_path__ + "static/media/ic_avatar_default.0fd4e76c86893e878595ce1ce695ca47.svg";
export { ForwardRef as ReactComponent };